<template>
    <div id="sexe-pie-chart">

    </div>
</template>

<script>
import Highcharts from 'highcharts';

export default {
    name: 'SexePieChart',
    props: {
        statistiques: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            series: []
        }
    },
    mounted() {
        this.buildSeries();
        this.buildChart();
    },
    methods: {
        buildSeries() {
            let percent_male = this.statistiques.male / (this.statistiques.male + this.statistiques.female);
            percent_male = percent_male * 100;
            percent_male = Number(percent_male.toFixed(2));
            let percent_female = this.statistiques.female / (this.statistiques.male + this.statistiques.female);
            percent_female = percent_female * 100;
            percent_female = Number(percent_female.toFixed(2));
            this.series = [
                {
                    name: 'Femmes (' + this.statistiques.female + ')',
                    y: percent_female
                },
                {
                    name: 'Hommes (' + this.statistiques.male + ')',
                    y: percent_male
                }
            ];
        },
        buildChart() {
            Highcharts.chart('sexe-pie-chart', {
                chart: {
                    type: 'pie',
                    zooming: {
                        type: 'xy'
                    },
                    panning: {
                        enabled: true,
                        type: 'xy'
                    },
                    panKey: 'shift'
                },
                title: {
                    text: 'Répartition par sexe'
                },
                tooltip: {
                    valueSuffix: '%'
                },

                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}: {point.percentage:.1f}%',
                            style: {
                                fontSize: '14px',
                                fontWeight: 'bold',
                                textOutline: '2px contrast',
                                color: '#ffffff'
                            },
                            connectorColor: 'transparent',
                            connectorWidth: 0,
                            distance: -60,
                            position: 'center'
                        }
                    }
                },
                series: [
                    {
                        name: 'Percentage',
                        colorByPoint: true,
                        data: this.series
                    }
                ]
            });
        }
    }
}

</script>

<style lang="scss" scoped></style>